<div
  class="base-modal"
  [class.size-compact]="size === 'compact'"
  [class.size-standard]="size === 'standard'"
  [class.size-wide]="size === 'wide'"
  [class.height-tall]="height === 'tall'"
  [class.height-standard]="height === 'standard'"
  [class.height-small]="height === 'small'"
  [style.--modal-width]="width"
  [style.--modal-bg]="effectiveBackgroundColor"
  [style.--modal-title-color]="effectiveTitleColor"
  [style.--modal-gradient-from]="effectiveGradientFrom"
  [style.--modal-gradient-to]="effectiveGradientTo"
  [style.--modal-close-color]="effectiveCloseIconColor"
  [style.--modal-close-opacity]="effectiveCloseIconOpacity"
  [style.--modal-title-font-size]="effectiveTitleFontSize ?? null"
  [style.--modal-title-font-weight]="effectiveTitleFontWeight"
  [style.--modal-full-gradient]="cssFullGradient"
  [style.--modal-header-bg]="cssHeaderBg"
  [style.--modal-header-backdrop]="cssHeaderBackdrop"
>
  <div class="header-sticky" [class.is-sticky]="stickyHeader">
    <div class="gradient-strip" aria-hidden="true"></div>

    <button
      *ngIf="showCloseIcon"
      type="button"
      class="close-button"
      aria-label="Close"
      (click)="closed.emit()"
    >
      <svg-icon src="assets/icons/icon-close.svg"></svg-icon>
    </button>

    <div class="modal-header" *ngIf="!hasCustomHeader">
      <h2 class="modal-title">{{ title }}</h2>
    </div>
    <div class="custom-header" *ngIf="hasCustomHeader">
      <ng-content select="[header]"></ng-content>
    </div>
  </div>

  <div class="modal-body">
    <ng-content></ng-content>
  </div>
  <div class="modal-actions">
    <ng-content select="[actions]"></ng-content>
  </div>
</div>
